import { sortBy } from 'lodash';
import {
  FormsNotificationsStatuses,
  FORMS_COMPLETE_NOTIFICATION_TEXT,
  FORMS_PENDING_NOTIFICATION_TEXT,
  Notification,
} from '../store/notifications/types';
import { UnreadNotificationStatusPrefix } from '../constants';

/**
 * This method will check if the notification status is unread
 * @param notification
 */
export const isUnreadNotification = (notification: Notification) =>
  notification.ownerId.split('/')[1].includes(UnreadNotificationStatusPrefix);

export const sortNotificationsByDate = (notifications: Notification[]) =>
  sortBy(notifications, 'createdDate').reverse();

/**
 * The notification entity keeps the entity corresponding to notification as the last part of
 * data property. Eg.
 * 656581fc-ac1f-4e66-a834-f91a43d06124/1_PENDING/b28bffe5-2534-477a-bcf1-598572da75f3
 * breaks down as
 * 656581fc-ac1f-4e66-a834-f91a43d06124 -> user for notification
 * 1_PENDING -> notification status
 * b28bffe5-2534-477a-bcf1-598572da75f3 -> related entityId for notification
 * @param notificationDataProperty ownerId/data property of notification entity
 * @returns related entityId for notification
 */
export const getEntityIDFromNotificationDataProperty = (
  notificationDataProperty: string,
) => {
  const dataPropertyParts = notificationDataProperty.split('/');
  return dataPropertyParts.length > 2 ? dataPropertyParts[2] : '';
};

/**
 * This method is used to convert forms notifications status
 * to action summary text.
 * @param status: form notification status
 */
export const getFormNotificationSummaryTitleByStatus = (
  status: FormsNotificationsStatuses,
) => {
  switch (status) {
    case FormsNotificationsStatuses.COMPLETED:
      return FORMS_COMPLETE_NOTIFICATION_TEXT;
    case FormsNotificationsStatuses.PENDING:
      return FORMS_PENDING_NOTIFICATION_TEXT;

    default:
      return '';
  }
};
